import { render, staticRenderFns } from "./ShopClose.vue?vue&type=template&id=b03b1a10&lang=pug&"
import script from "./ShopClose.vue?vue&type=script&lang=js&"
export * from "./ShopClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports